
























































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class ServiceCard extends Vue {
  @Prop({ type: String, default: "" }) title!: string;
  @Prop({ type: String, default: "" }) description!: string;
  @Prop({ type: String, default: "" }) price!: string;
  @Prop({ type: String, default: "" }) imageUrl!: string;
  @Prop({ type: String, default: "" }) ctaLabel!: string;
  @Prop({ type: String, default: "" }) priceLabel!: string;
  @Prop({ type: String, default: "default" }) bottomVariant!: string;
  @Prop({ type: String, default: "default" }) variant!: string;
  // When set, the title renders as a real <a href> so crawlers can follow it
  @Prop({ type: String, default: "" }) href!: string;
  @Prop({ type: Boolean, default: true }) showMedia!: boolean;
  @Prop({ type: Boolean, default: false }) imageContain!: boolean;

  descExpanded = false;
  isDescTruncated = false;
  descriptionMaxLines = 3;

  get displayCtaLabel() {
    return this.ctaLabel !== ""
      ? this.ctaLabel
      : this.$t("Book now").toString();
  }

  get displayPriceLabel() {
    return this.priceLabel !== ""
      ? this.priceLabel
      : this.$t("Price").toString();
  }

  get displayPriceFromLabel() {
    return this.priceLabel !== ""
      ? this.priceLabel
      : this.$t("Prices from").toString();
  }

  get usePriceBar() {
    return this.bottomVariant === "price-bar";
  }

  get showPrice() {
    return this.price !== "" && this.price !== null && this.price !== undefined;
  }

  mounted() {
    this.$nextTick(() => this.checkTruncation());
    window.addEventListener("resize", this.checkTruncation);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.checkTruncation);
  }

  checkTruncation() {
    const el = this.$refs.descText as HTMLElement | undefined;
    if (!el) return;
    // Mide la altura real vs la altura con clamp aplicado
    const prevClass = el.className;
    el.classList.remove("servicesCard__descText--clamped");
    const fullHeight = el.scrollHeight;
    el.className = prevClass;
    const clampedHeight = el.clientHeight;
    this.isDescTruncated = fullHeight > clampedHeight + 2;
  }

  toggleDesc() {
    this.descExpanded = !this.descExpanded;
    if (!this.descExpanded) this.$nextTick(() => this.checkTruncation());
  }
  emitAction() {
    this.$emit("action");
  }
}
